<template>
  <div>
    <PageAllow controller="Shops" action="getShopBalanceHistories" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1 pe-2">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click="shopBalanceHistoryExport()"
                v-if="
                  $permission.permissionAllow(
                    'Shops',
                    'shopBalanceHistoryExport'
                  )
                "
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>

                {{ $t("accountHistory.export") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <v-row dense align="center" class="pa-1 pe-2">
                    <SearcherShops v-model="shopsSelected"
                  /></v-row>
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="
                    $permission.permissionAllow('BalanceCategories', 'index')
                  "
                >
                  <v-row dense align="center" class="pa-1 pe-2">
                    <v-autocomplete
                      v-model="options.balance_category_ids"
                      :items="balance_categories"
                      :loading="balanceCategoryLoading"
                      item-value="id"
                      item-text="category_name"
                      item-disabled="disabled"
                      :label="$t('accountHistory.balanceCategories')"
                      clearable
                      multiple
                      small-chips
                    >
                    </v-autocomplete> </v-row
                ></v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-row dense align="center" class="pa-1 pe-2">
                    <SearcherDistrictsWithDescendants v-model="districtsSelected" />
                  </v-row>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="shopBalanceHistories"
          :loading="loading"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          multi-sort
          class="elevation-2 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <!-- 客户名称 -->
          <template v-slot:item.shop_name="{ item }">
            {{
              $t("accountHistory.shop_name", [
                item.shop.shop_code,
                item.shop.shop_name,
              ])
            }}
          </template>
          <!-- 时间 -->
          <template v-slot:item.created="{ item }">
            {{ item.created }}
          </template>

          <!-- 收款 -->
          <template v-slot:item.price="{ item }">
            <span v-if="item.io_type == 1">
              {{ $t("Global.money")
              }}{{ item.io_type == 1 ? item.price : "" | formatMoney }}
            </span>
          </template>
          <!-- 付款 -->
          <template v-slot:item.pay="{ item }">
            <span v-if="item.io_type == 2">
              {{ $t("Global.money")
              }}{{ item.io_type == 2 ? item.price : "" | formatMoney }}
            </span>
          </template>

          <template v-slot:item.balance="{ item }">
            {{ $t("Global.money") }}{{ item.balance | formatMoney }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
              v-if="
                $permission.permissionAllow('Shops', 'getShopBalanceHistories')
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  v-if="item.bill_id"
                  :href="'/#/receipts/' + item.bill_id"
                >
                  <v-icon x-small class="pe-1">fa-align-left</v-icon>
                  {{ $t("accountHistory.view") }}
                </v-btn>
              </template>
              <span>{{ $t("accountHistory.view") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import Shop from "@/api/shops";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import BalanceCategories from "@/api/balance_categories";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  balance_category_ids: [],
  shop_ids: [],
  district_ids: [],
};

export default {
  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("account-history-options")
        ? sessionStorage.getItem("account-history-options")
        : JSON.stringify(defaultOptions)
    ),
    // options: JSON.parse(JSON.stringify(defaultOptions)),
    shopBalanceHistories: [],
    paging: {},
    balanceCategoriesSelected: [],
    balance_categories: [],
    balanceCategoryLoading: "",
    shopsSelected: [],
    districtsSelected:[],
  }),
  mounted() {
    this.getShopFromAPI();
    this.getBalanceCategoriesFromAPI();
    this.$commonUtils
      .loadOptions("account-history", [
        "shopsSelected",
        "districtsSelected",
      ]).then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
           data.selecteds.forEach((selected) => {
             switch (selected.key) {
               case "shopsSelected":
                 this.shopsSelected = selected.value;
                 break;
               case "districtsSelected":
                 this.districtsSelected = selected.value;
                 break;
             }
           });
        }.bind(this)
    );
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.capital"),
        disabled: false,
        href: "/capital",
      },
      {
        text: i18n.t("Nav.accountHistory"),
        disabled: true,
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("accountHistory.date"),
      },
    ],
    headers() {
      var headers = [
        {
          text: i18n.t("accountHistory.Fields.shop_name", [
            this.$consts.shopName(),
          ]),
          align: "center",
          sortable: false,
          value: "shop_name",
        },
        {
          text: i18n.t("accountHistory.Fields.created"),
          align: "center",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("accountHistory.Fields.operation_str"),
          align: "center",
          sortable: false,
          value: "operation_str",
        },
        {
          text: i18n.t("accountHistory.Fields.price"),
          align: "center",
          sortable: false,
          value: "price",
        },
        {
          text: i18n.t("accountHistory.Fields.pay"),
          align: "center",
          sortable: false,
          value: "pay",
        },
        {
          text: i18n.t("accountHistory.Fields.balance"),
          align: "center",
          sortable: false,
          value: "balance",
        },
      ];
      if (this.$permission.permissionAllow("BalanceCategories", "index")) {
        headers.push({
          text: i18n.t("accountHistory.Fields.balanceCategories"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "balance_category.category_name",
        });
      }
      headers.push(
        {
          text: i18n.t("accountHistory.Fields.comment"),
          align: "center",
          sortable: false,
          value: "comment",
        },
        {
          text: i18n.t("accountHistory.Fields.creater_name"),
          align: "center",
          sortable: false,
          value: "creater_name",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "center",
          sortable: false,
          value: "actions",
        }
      );
      return headers;
    },

    ...mapState(["loading"]),
  },

  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherShops,
    SearcherDistrictsWithDescendants,
  },
  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options);
    },
    resetSearch() {
      this.shopsSelected = [];
      this.districtsSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getAccountHistoryFromAPI() {
      Shop.accountHistory(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shopBalanceHistories = response.data.shopBalanceHistories;
            this.paging = response.data.paging;
          }
        }.bind(this)
      );
    },
    getBalanceCategoriesFromAPI() {
      this.balanceCategoryLoading = true;
      BalanceCategories.fetchAll({}).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.balanceCategoryLoading = false;
            this.balance_categories = response.data.balance_categories;
          }
          this.balanceCategoryLoading = false;
        }.bind(this)
      );
    },
    getShopFromAPI() {
      Shop.fetchAllForSelect({}).then(
        function (response) {
          if (response.data.status.isOK()) {
            var shops = response.data.shops;
            if (this.$route.query.shopId) {
              let res = shops.filter((v) => {
                return v.id == this.$route.query.shopId;
              });
              this.shopsSelected = res;
            }
          }
        }.bind(this)
      );
    },
    shopBalanceHistoryExport() {
      Shop.shopBalanceHistoryExport(this.options);
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getAccountHistoryFromAPI();
        sessionStorage.setItem("account-history-options", JSON.stringify(this.options));
      },
    },
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((e) => {
              return e.id;
            })
          : [];
        sessionStorage.setItem(
          "account-history-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    districtsSelected: {
      handler() {
        this.options.district_ids = this.districtsSelected
          ? this.districtsSelected.map((e) => {
              return e.id;
            })
          : [];
        sessionStorage.setItem(
          "account-history-districtsSelected",
          JSON.stringify(this.districtsSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>